import { FetchCrudData, FoodType } from '../../models';
import { FoodTypesService } from '../../services';
import { ActionType } from './types';

export const getFoodTypes = (filters: FetchCrudData) => ({
  type: ActionType.GET_FOODTYPES,
  payload: FoodTypesService.getFoodTypes(filters),
});
export const getMoreFoodTypes = (filters: FetchCrudData) => ({
  type: ActionType.GET_MORE_FOODTYPES,
  payload: FoodTypesService.getFoodTypes(filters),
});
export const getFoodTypeWithMinHoldingTime = () => ({
  type: ActionType.GET_FOODTYPE_WITH_MIN_HOLDING_TIME,
  payload: FoodTypesService.getFoodTypeWithMinHoldingTime(),
});
export const addFoodTypes = (foodType: FoodType) => ({
  type: ActionType.ADD_FOODTYPES,
  payload: FoodTypesService.addFoodTypes(foodType),
});
export const editFoodTypes = (foodType: FoodType) => ({
  type: ActionType.EDIT_FOODTYPES,
  payload: FoodTypesService.editFoodTypes(foodType),
});
export const deleteFoodTypes = (id: string) => ({
  type: ActionType.DELETE_FOODTYPES,
  payload: FoodTypesService.deleteFoodTypes(id),
});
